exports.BLANK_QUESTION = {
    Index: 1,
    Question: [{ _id: 'en', Value: '' }],
    Languages: [{ id: 'en', text: 'English' }],
    InHint: '',
    OutHint: '',
    Field: '',
    Optional: false,
    LoopParent: '',
    InputType: 2,
    Default: '',
    Format: '',
    Min: '',
    Max: '',
    Step: 1,
    Skip: false,
    NumType: 'I',
    Lines: 1,
    Width: 640,
    Height: '',
    Quality: 85,
    Pre: '',
    Post: '',
    Filter: false,
    Manual: false,
    Local: false,
    Timeout: 20,
    Accuracy: 10,
    GPSSkip: true,
    ShowRules: [], // Rules to pass for showing the question.
    PassRules: [], // Rules to allow question answer and jump.
    RatingRules: [], // Rules for rating bands.
    Options: [] // Option list in case of list question type.
};

exports.END_QUESTION = 9999;

exports.EXPOSURE = [
    { id: 'I', text: 'Internal (Requires login)' },
    { id: 'E', text: 'External (Open to anyone)' }
];

exports.ICON_LIST = [
    'mdi-circle-off-outline',
    'mdi-leaf',
    'mdi-tree',
    'mdi-tree-outline',
    'mdi-pine-tree',
    'mdi-feather',
    'mdi-corn',
    'mdi-food-apple-outline',
    'mdi-fruit-grapes-outline',
    'mdi-fruit-watermelon',
    'mdi-seed-outline',
    'mdi-sprout-outline',
    'mdi-barley',
    'mdi-bee-flower',
    'mdi-bug-outline',
    'mdi-virus-outline',
    'mdi-bacteria-outline',
    'mdi-barn',
    'mdi-barrel',
    'mdi-axe',
    'mdi-shovel',
    'mdi-bucket-outline',
    'mdi-water-outline',
    'mdi-waves',
    'mdi-wallpaper',
    'mdi-wall',
    'mdi-volleyball',
    'mdi-egg-outline',
    'mdi-bash',
    'mdi-air-horn',
    'mdi-lightning-bolt-outline',
    'mdi-car-light-high',
    'mdi-air-filter',
    'mdi-smoking-pipe',
    'mdi-face-man-outline',
    'mdi-face-woman-outline',
    'mdi-baby-face-outline',
    'mdi-account-circle-outline',
    'mdi-account-cowboy-hat',
    'mdi-account',
    'mdi-account-group',
    'mdi-account-hard-hat',
    'mdi-account-multiple',
    'mdi-account-tie',
    'mdi-account-voice',
    'mdi-card-account-details-outline',
    'mdi-badge-account-horizontal-outline',
    'mdi-school-outline',
    'mdi-map-marker-outline',
    'mdi-apple-safari',
    'mdi-fire-hydrant',
    'mdi-atom-variant',
    'mdi-hospital-box-outline',
    'mdi-car-battery',
    'mdi-battery-charging-outline',
    'mdi-beer-outline',
    'mdi-book-outline',
    'mdi-bookshelf',
    'mdi-bottle-soda-classic-outline',
    'mdi-bottle-tonic-plus-outline',
    'mdi-bottle-tonic-skull-outline',
    'mdi-bowl-mix-outline',
    'mdi-cash-multiple',
    'mdi-calendar-month-outline',
    'mdi-stove',
    'mdi-pot-steam-outline',
    'mdi-campfire',
    'mdi-fire',
    'mdi-bike',
    'mdi-motorbike',
    'mdi-car',
    'mdi-truck-outline',
    'mdi-bus',
    'mdi-train',
    'mdi-airplane',
    'mdi-cow',
    'mdi-pig',
    'mdi-dog',
    'mdi-fish',
    'mdi-pig-variant',
    'mdi-rabbit',
    'mdi-donkey',
    'mdi-spider',
    'mdi-rodent',
    'mdi-paw',
    'mdi-ab-testing',
    'mdi-abacus',
    'mdi-access-point',
    'mdi-account-star-outline',
    'mdi-adjust',
    'mdi-airballoon-outline',
    'mdi-alarm-light-outline',
    'mdi-alert-box-outline',
    'mdi-alert-circle-outline',
    'mdi-alert-octagon-outline',
    'mdi-alert-octagram-outline',
    'mdi-alert-outline',
    'mdi-alert-rhombus-outline',
    'mdi-check-circle-outline',
    'mdi-check-decagram-outline',
    'mdi-checkbox-multiple-marked-outline',
    'mdi-alien-outline',
    'mdi-all-inclusive',
    'mdi-anchor',
    'mdi-android',
    'mdi-apple-ios',
    'mdi-apple',
    'mdi-android-studio',
    'mdi-apple-icloud',
    'mdi-cloud-outline',
    'mdi-application-edit-outline',
    'mdi-archive-outline',
    'mdi-arrow-decision-outline',
    'mdi-atom',
    'mdi-attachment',
    'mdi-clippy',
    'mdi-auto-fix',
    'mdi-av-timer',
    'mdi-baby-carriage',
    'mdi-bag-personal-outline',
    'mdi-bandage',
    'mdi-bank-outline',
    'mdi-barcode',
    'mdi-basketball',
    'mdi-bat',
    'mdi-bathtub-outline',
    'mdi-battery-medium',
    'mdi-beach',
    'mdi-bed-outline',
    'mdi-beehive-outline',
    'mdi-bell-outline',
    'mdi-biohazard',
    'mdi-bird',
    'mdi-brightness-2',
    'mdi-brightness-5',
    'mdi-brush-variant',
    'mdi-bulldozer',
    'mdi-bullseye-arrow',
    'mdi-bus-stop',
    'mdi-calendar-star',
    'mdi-cards-outline',
    'mdi-carrot',
    'mdi-cash-100',
    'mdi-charity',
    'mdi-chart-arc',
    'mdi-chart-areaspline',
    'mdi-chart-bell-curve-cumulative',
    'mdi-clipboard-text-multiple-outline',
    'mdi-clipboard-text-outline',
    'mdi-coffee-outline',
    'mdi-coffin',
    'mdi-comma-circle-outline',
    'mdi-comment-multiple-outline',
    'mdi-content-paste',
    'mdi-counter',
    'mdi-crane',
    'mdi-creation',
    'mdi-cross-outline',
    'mdi-diamond-stone',
    'mdi-dice-6-outline',
    'mdi-dump-truck',
    'mdi-earth',
    'mdi-email-multiple-outline',
    'mdi-engine-outline',
    'mdi-fingerprint',
    'mdi-fire-extinguisher',
    'mdi-flash',
    'mdi-foot-print',
    'mdi-ghost-outline',
    'mdi-hand-wash-outline',
    'mdi-crowd',
    'mdi-crown-outline',
    'mdi-sprinkler-fire',
    'mdi-sickle',
    'mdi-sign-caution',
    'mdi-silverware-fork-knife',
    'mdi-sim-outline',
    'mdi-slot-machine',
    'mdi-solar-power',
    'mdi-space-invaders',
    'mdi-space-station',
    'mdi-speedometer',
    'mdi-spray',
    'mdi-star-circle-outline',
    'mdi-stethoscope',
    'mdi-store-outline',
    'mdi-storefront-outline',
    'mdi-tooth-outline',
    'mdi-toothbrush',
    'mdi-tower-fire',
    'mdi-town-hall',
    'mdi-tractor-variant',
    'mdi-warehouse',
    'mdi-water-pump',
    'mdi-watering-can-outline',
    'mdi-wheel-barrow',
    'mdi-math-compass',
    'mdi-moped-outline',
    'mdi-needle',
    'mdi-package-variant',
    'mdi-paper-roll-outline',
    'mdi-propane-tank-outline',
    'mdi-rake',
    'mdi-recycle',
];

exports.INPUT = {
    InHint: 1, // Hint inside input box.
    OutHint: 2, // Hint outside/underneath input box.
    LoopParent: 3, // Parent question id for looping count.
    Default: 4, // Default value.
    Format: 5, // Formatting.
    Min: 6, // Minimum. Can be for chars or list item selection.
    Max: 7, // Maximum. Can be for chars or list item selection.
    Step: 8, // Step count for stepper.
    Skip: 9, // Optional. Allow skipping question.
    NumType: 10, // Number type for int and decimal.
    Lines: 11, // Number of input lines.
    Width: 12, // Image width.
    Height: 13, // Image height.
    Quality: 14, // Image quality.
    Pre: 15, // Prefix.
    Post: 16, // Postfix.
    Filter: 17, // List filter textbox.
    Manual: 18, // Enter barcode manually.
    Local: 19, // Allow loading of local image file.
    Timeout: 20, // GPS timeout allowance.
    Accuracy: 21, // GPS accuracy (meters).
    GPSSkip: 22 // Allow continuing even if GPS accuracy not good.
};
exports.INPUT_TYPE = {
    Note: 1,
    Text: 2,
    Number: 3,
    Mobile: 4,
    Email: 5,
    WebAddress: 6,
    YesNo: 7,
    SelectOne: 8,
    SelectMany: 9,
    Date: 10,
    Time: 11,
    DateOfBirth: 12,
    Rating: 13,
    RangeSlider: 14,
    Image: 15,
    Signature: 16,
    GPSLocation: 17,
    Barcode: 18,
    User: 19
};
exports.NUMBER_TYPE = [
    { id: 'I', text: 'Integer / Whole Number', type: 'int' },
    { id: 'D', text: 'Decimal', type: 'number' }
];

exports.NO_IMAGE = 'data:image/png;base64,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';

exports.LANGUAGES = [
    { id: 'en', text: 'English' },
    { id: 'af', text: 'Afrikaans' },
    { id: 'km', text: 'Khmer' },
    { id: 'lo', text: 'Lao' }
    // { id: 'ny', text: 'Chichewa' }
];
exports.PAGE_SIZE_5 = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100];

exports.PERMISSION_LIST = [
    { id: 0, text: 'Access API' },
    { id: 1, text: 'Access Web Console' },
    { id: 2, text: 'Access Mobile' },
    // { id: 1, text: 'Company Access' },
    // { id: 2, text: 'Company View' },
    // { id: 3, text: 'Company Edit' },
    { id: 20, text: 'Project Access' }, // Group
    { id: 21, text: 'Project View' }, // Group
    { id: 22, text: 'Project Edit' }, // Group
    { id: 40, text: 'Form Access' },
    { id: 41, text: 'Form View' },
    { id: 42, text: 'Form Edit' },
    { id: 43, text: 'Form Approver' },
    { id: 60, text: 'Role Access' },
    { id: 61, text: 'Role View' },
    { id: 62, text: 'Role Edit' },
    { id: 80, text: 'Staff Access' },
    { id: 81, text: 'Staff View' },
    { id: 82, text: 'Staff Edit' },
    { id: 83, text: 'Staff Projects' },
    { id: 84, text: 'Staff Roles' },
    { id: 85, text: 'Staff Password' },
    { id: 100, text: 'Reports' },
    { id: 101, text: 'Report Setup' },
];
exports.PERMISSION = {
    SELF: 0,
    ACCESS_API: 1,
    ACCESS_WEB: 2,
    ACCESS_MOBILE: 3,
    // COMPANY_ACCESS: 1,
    // COMPANY_VIEW: 2,
    // COMPANY_EDIT: 3,
    GROUP_ACCESS: 20,
    GROUP_VIEW: 21,
    GROUP_EDIT: 22,
    SURVEY_ACCESS: 40,
    SURVEY_VIEW: 41,
    SURVEY_EDIT: 42,
    SURVEY_APPROVER: 43,
    ROLE_ACCESS: 60,
    ROLE_VIEW: 61,
    ROLE_EDIT: 62,
    STAFF_ACCESS: 80,
    STAFF_VIEW: 81,
    STAFF_EDIT: 82,
    STAFF_PROJECTS: 83,
    STAFF_ROLES: 84,
    STAFF_PASSWORD: 85,
    REPORTS: 100,
    REPORT_EDIT: 101,
    FULL_ADMIN: 9999, // No restrictions.
};

exports.RELATIONSHIP_TYPE = [
    { id: 'N', text: 'None' },
    // { id: 'S', text: 'Survey' },
    { id: 'M', text: 'Primary List' }
];

exports.SEARCH_OPTIONS = ['Starts with', 'Ends with', 'Anywhere in text', 'Exact match', 'Not equal to'];
exports.SEARCH_AT_OPTIONS = [
    { text: 'Starts', value: 'start', icon: 'mdi-format-horizontal-align-left' }, // mdi-toggle-switch-off
    { text: 'Ends', value: 'end', icon: 'mdi-format-horizontal-align-right' }, // mdi-toggle-switch
    { text: 'Contains', value: 'any', icon: 'mdi-format-letter-matches' },
    { text: 'Exact', value: 'exact', icon: 'mdi-equal' },
    { text: 'Not', value: 'not', icon: 'mdi-not-equal-variant' }
];
exports.SEARCH_STRING = [
    { text: 'Starts', value: 'start', icon: 'mdi-format-horizontal-align-left' },
    { text: 'Ends', value: 'end', icon: 'mdi-format-horizontal-align-right' },
    { text: 'Contains', value: 'any', icon: 'mdi-format-letter-matches' },
    { text: 'Exact', value: 'exact', icon: 'mdi-equal' },
    { text: 'Not', value: 'not', icon: 'mdi-not-equal-variant' },
    { text: 'In List', value: '[]', icon: 'mdi-code-brackets' },
];
exports.MATCH_MATH = [
    { text: 'Equals', value: '=', icon: 'mdi-equal' },
    { text: 'Not Equals', value: '!=', icon: 'mdi-not-equal-variant' },
    { text: 'Greater Than', value: '>', icon: 'mdi-greater-than' },
    { text: 'Less Than', value: '<', icon: 'mdi-less-than' },
    { text: 'Greater Than Or Equal', value: '>=', icon: 'mdi-greater-than-or-equal' },
    { text: 'Less Than Or Equal', value: '<=', icon: 'mdi-less-than-or-equal' },
    { text: 'In List', value: '[]', icon: 'mdi-code-brackets' },
    { text: 'Between', value: '&', icon: 'mdi-arrow-expand-horizontal' },
];
exports.MATCH_BOOL = [
    { text: 'Equals', value: '=', icon: 'mdi-equal' },
    { text: 'Not Equals', value: '!=', icon: 'mdi-not-equal-variant' },
];

exports.STATUS = [
    { id: 'A', text: 'Active', color: 'success' },
    { id: 'N', text: 'Not Active', color: 'error' },
    { id: 'D', text: 'Draft', color: 'warning' },
    { id: 'H', text: 'Hidden (Web)', color: 'info' }
];
exports.STATUS_BACKUP_FILTER = [
    { id: '', text: 'All', color: 'primary' },
    { id: 'D', text: 'Done', color: 'success' },
    { id: 'S', text: 'Started', color: 'warning' },
    { id: 'F', text: 'Failed', color: 'error' },
    { id: 'Z', text: 'No Data', color: 'info' }
];
exports.STATUS_FILTER = [
    { id: '', text: 'All', color: 'primary' },
    { id: 'A', text: 'Active', color: 'success' },
    { id: 'N', text: 'Not Active', color: 'error' },
    { id: 'D', text: 'Draft', color: 'warning' },
    { id: 'H', text: 'Hidden (Web)', color: 'info' }
];
exports.STATUS_LOGS = [
    { id: 'S', text: 'Sent', color: 'success' },
    { id: 'F', text: 'Failed', color: 'error' },
    { id: 'PF', text: 'Pending', color: 'warning' }
];
exports.STATUS_USER = [
    { id: 'A', text: 'Active', color: 'success' },
    { id: 'L', text: 'Locked', color: 'error' }
];
exports.STATUS_USER_FILTER = [
    { id: '', text: 'All', color: 'primary' },
    { id: 'A', text: 'Active', color: 'success' },
    { id: 'L', text: 'Locked', color: 'error' }
];

exports.THEME = {
    LIGHT: {
        PRIMARY: '#2F383D',
        SECONDARY: '#2F383D',
        ACCENT: '#A7124A', // #DE2329 #FF3A30
        ERROR: '#F56C6C',
        INFO: '#409EFF',
        SUCCESS: '#67C23A',
        WARNING: '#E6A23C',
        TITLEBAR_BACK: '#FFFFFF',
        TITLEBAR_TEXT: '#333333',
        MENU_BACK: '#FAFAFA',
        MENU_TEXT: '#555555',
        MENU_SELECTED_BACK: '#E5E5E5',
        MENU_SELECTED_TEXT: '#222222'
    },
    DARK: {
        PRIMARY: '#604B41',
        SECONDARY: '#638856',
        ACCENT: '#85B973',
        ERROR: '#F56C6C',
        INFO: '#409EFF',
        SUCCESS: '#67C23A',
        WARNING: '#E6A23C',
        TITLEBAR_BACK: '#222222',
        TITLEBAR_TEXT: '#DDDDDD',
        MENU_BACK: '#444444',
        MENU_TEXT: '#DDDDDD',
        MENU_SELECTED_BACK: '#F5F5F5',
        MENU_SELECTED_TEXT: '#555555'
    }
};

exports.YES_NO_LIST = [
    { id: true, text: 'Yes' },
    { id: false, text: 'No' }
];

exports.RULE_INFO_TEXT = `
==========================================================================================
Q  - Question
@  - Current Q value
>> - Jump to Q

Symbol & Name               Condition                   Next Condition
==========================================================================================
# Options id                @ == #2 (only valid for Select One and Select Many)
== Equal to                 @ == TextVal                {9} == "Water Buck" >> 15
!= Not equal to             @ != TextVal                {9} != TextVal >> 15
> Greater than              @ > 2                       {9} > TextVal >> 15
>= Greater than or equals   @ >= 2                      {9} >= TextVal >> 15
< Less than                 @ < 10                      {9} < TextVal >> 15
<= Less than or equals      @ <= 10                     {9} <= TextVal >> 15
^ Starts with               @^Mai                       {9}^TextVal >> 15
[] Format                   @[999999/99/9]              {9}[999999/99/9] >> 15
&& And                      @ == TextVal && AnotherVal  {9} == TextVal && AnotherVal >> 15
|| Or                       @ == TextVal || AnotherVal  {9} == TextVal || AnotherVal >> 15
() Group                    @ == (1 && 2) || (11 && 12) {9} == (1 && 2) || (11 && 12) >> 15
{} Ref to other Q value     @ == {8}                    {9} == {8} >> 15
time (input within 23:59)   @ == time
today (must equal today)    @ == today
// Regular expression       @ == /[^0-9]/
==========================================================================================
Complex examples
==========================================================================================
@ == {8} && {5} == mysupervalue
@ >= 0 && @ <= 2.5 || @ >= 5 && @ <= 10 || @ >= 20 && @ <= 50 >> 9
@ == 'TextOne'||'TextTwo'
==========================================================================================
`;

exports.AUTO_INFO_TEXT = `These fields are generated and incremented on each form submission.<br/>
Specify a unique field name that the number will be stored in.<br/>
Use <b>{NUM}</b> or leave the format field blank to have the value generated as a normal number starting at <b>1</b>.<br/><br/>

Example formats:<br/>
Use a prefix and/or suffix: <b>MW180-{NUM}</b> yields MW180-1<br/>
Specify zero (0) padding: <b>MW180-{NUM:000}</b> yields MW180-001<br/>
If the number exceeds the padding length, the padding is simply ignored.<br/><br/>

Special fields to use in the format:<br/>
<b>{DATE}</b> yields the date as YYYYMMDD e.g. 20200814<br/>
<b>{DATE_NUM}</b> yields a number which is the milliseconds that have passed since 1970.<br/>
<b>{COUNTRY_CODE}</b> yields the country code gathered from GPS. !! Note that a GPS question must be in the form and must be mandatory to be able to gather the code.<br/>
`;
